import React from "react";
import Authors from "./Authors.js";

export default ({ date, authors }) => (<div className="ArticleMeta">
  <Authors authors={authors} /><div>&nbsp;•&nbsp;</div><div className="ff--basis label">{date}</div>
</div>)